import { render, staticRenderFns } from "./PremiumCongratsModal.vue?vue&type=template&id=de1ab32e&"
import script from "./PremiumCongratsModal.vue?vue&type=script&lang=js&"
export * from "./PremiumCongratsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports